<template>
  <v-chip dark :small="small" :icon="icon" v-bind="$attrs" :color="color" @click="$emit(action)">
    <v-icon left class="mx-0" v-if="icon">
      {{ icon }}
    </v-icon>
    &nbsp;{{ title }}
  </v-chip>
</template>

<script>
// @group Global Component
export default {
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: "Simpan"
    },
    color: {
      type: String,
      default: "primary"
    },
    isBlock: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: "save"
    }
  },
  computed: {
    small() {
      return this.$vuetify.breakpoint.smAndUp ? false : true;
    }
  }
};
</script>
